export enum DischargePlanningQuestionnaireItem {
  DISCHARGE_PLANNING = 'discharge-planning',
  DISCHARGE_PLANNING_DISCHARGE_PLANS = 'discharge-planning/discharge-plans',
  DISCHARGE_PLANNING_REHABILITATION_POTENTIAL = 'discharge-planning/rehabilitation-potential',
  DISCHARGE_PLANNING_NOTES = 'discharge-planning/notes'
}
